import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { I18nTranslator, translations } from "utils/i18n";
import { ReceiveActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { IReceiveDetail } from "model";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { useParams } from "react-router-dom";

const ImportPalletDetail = () => {
  const dispatch = useAppDispatch();
  const params = useParams<{
    stockReceivingCode: string;
  }>();
  const [refresh, setRefresh] = useState(false);

  const data = useAppSelector(
    (state) => state.ReceiveReducer.palletDetail?.data
  ) as IPaginateApiResponse<IReceiveDetail[]>;
  const mainAction = useAppSelector((state) => state.ReceiveReducer.action);
  const action = useAppSelector(
    (state) => state.ReceiveReducer.palletDetail?.action
  );

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    _getImportPalletDetail();
  }, [searchText, refresh]);

  const _getImportPalletDetail = (pageNumber = 1) => {
    dispatch(
      ReceiveActions.getImportPalletDetail.request({
        pageNumber: pageNumber,
        pageSize: 100,
        stockReceivingCode: params.stockReceivingCode,
        searchText: searchText,
      })
    );
  };
  const _handlePageSizeChange = (pageSize: number) => {
    dispatch(
      ReceiveActions.getImportPalletDetail.request({
        pageNumber: 1,
        pageSize: pageSize,
        stockReceivingCode: params.stockReceivingCode,
        searchText: searchText,
      })
    );
  };

  useEffect(() => {
    if (mainAction.includes(ReceiveActions.importReceiveDocument.successName)) {
      setRefresh(true);
      dispatch(ReceiveActions.clearAction.request());
    }
  }, [mainAction]);

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "strStatus",
      headerName: I18nTranslator(translations.receive.status),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productId),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productName",
      headerName: I18nTranslator(translations.receive.productName),
      size: "medium",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "uom",
      headerName: I18nTranslator(translations.receive.uom),
      size: 100,
      align: "center",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.batchCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.receive.location),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.receive.quantity),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "strExpiredDate",
      headerName: I18nTranslator(translations.receive.expiredDate),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.batchCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "specification",
      headerName: I18nTranslator(translations.receive.palletSpecification),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "receiver",
      headerName: I18nTranslator(translations.receive.receiver),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "strReceiveDateTime",
      headerName: I18nTranslator(translations.receive.receivedDate),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "forklift",
      headerName: I18nTranslator(translations.receive.forklift),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "strSetLocationDateTime",
      headerName: I18nTranslator(translations.receive.loadedDate),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.receive.note),
      size: "medium",
      align: "left",
      editable: true,
    }),
  ];

  return (
    <AppTable
      columns={COLUMNS}
      data={data}
      loading={action.includes(
        ReceiveActions.getImportPalletDetail.requestName
      )}
      onSearch={setSearchText}
      searchPlaceholder={
        "Tìm kiếm: Mã lô, mã sản phẩm, tên sản phẩm, khu vực, vị trí"
      }
      onChangePage={(pageNumber) => _getImportPalletDetail(pageNumber)}
      removeActionColumn
      hideHeader
      defaultHeaderTable={350}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default ImportPalletDetail;
